/**
 * Deep links into the status monitor.
 *
 * The status page filters by the feed's cluster id, which is the config's
 * `cluster_name`, and searches across addresses, so a config can point at
 * exactly its own row there. Standalone packs carry the sentinel cluster
 * name 'default', which is not a cluster, so those link by address.
 */
export function statusMonitorPathFor(target: { cluster?: string | null; address?: string | null }): string {
  const params = new URLSearchParams();
  if (target.cluster && target.cluster !== 'default') params.set('cluster', target.cluster);
  if (target.address) params.set('q', target.address);
  const query = params.toString();
  return `/status-monitor${query ? `?${query}` : ''}`;
}
